import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'overlayscrollbars/overlayscrollbars.css';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import App from "./App";
import Login from "./Login";
import {LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import Mobile from "./App/Mobile";
import 'dayjs/locale/en-gb';
import {createTheme, CssBaseline, ThemeProvider} from "@mui/material";
import CreateAccount from "./CreateAccount";

const darkTheme = createTheme({
    palette: {
        mode: 'dark',
    },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={localStorage.getItem('tm-locale') || 'en-gb'}>
            <ThemeProvider theme={darkTheme}>
                <CssBaseline />
                <BrowserRouter basename={process.env.PUBLIC_URL}>
                    <Routes path="/">
                        <Route index element={<App />} />
                        <Route path="login" element={<Login />} />
                        <Route path="mobile" element={<Mobile />} />
                        <Route path="create" element={<CreateAccount />} />
                        <Route path='*' element={<>404</>} />
                    </Routes>
                </BrowserRouter>
            </ThemeProvider>
        </LocalizationProvider>
    </React.StrictMode>
);
